import { Cell, Label, Pie, PieChart } from "recharts";

const CenterLabel = ({ viewBox, value = 0, title = "title" }) => {
  const { cx, cy } = viewBox;

  return (
    <>
      <text x={cx - 15} y={cy - 15}>
        <tspan
          fill="#000"
          dominantBaseline={"central"}
          fontSize={"24px"}
          fontFamily="Poppins, serif"
        >
          {value}
        </tspan>
      </text>
      <text x={cx - 52} y={cy + 15}>
        <tspan
          fill="#000"
          dominantBaseline={"central"}
          fontSize={"11px"}
          fontFamily="Poppins, serif"
        >
          {title}
        </tspan>
      </text>
    </>
  );
};

const renderCustomizedLabel = (viewBox, values) => {
  const { index, x, y } = viewBox;
  if (!values[index]?.value) return <></>;

  return (
    <>
      <text
        x={x}
        y={y + 15}
        fill="#6B4750"
        textAnchor="middle"
        dominantBaseline={"central"}
        fontSize={"12px"}
        fontFamily="Poppins, serif"
      >
        {values[index]?.name}
      </text>
      <text
        x={x}
        y={y}
        fill="#6B4750"
        textAnchor="middle"
        dominantBaseline={"central"}
        fontSize={"10px"}
        fontFamily="Poppins, serif"
      >
        {values[index]?.value?.toLocaleString()}
      </text>
    </>
  );
};

const CustomPieChart = ({
  width = 500,
  height = 500,
  data,
  centerLabel,
  innerRadius = 0,
}) => {
  return (
    <PieChart width={width} height={height}>
      <Pie
        data={data}
        cx="50%"
        cy="50%"
        labelLine={false}
        label={(viewBox) => renderCustomizedLabel(viewBox, data)}
        outerRadius={100}
        innerRadius={innerRadius}
        fill="#6B4750"
        dataKey="value"
        strokeWidth={5}
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.fill} />
        ))}
        {centerLabel?.title ? (
          <Label
            content={({ viewBox }) => (
              <CenterLabel
                viewBox={viewBox}
                value={centerLabel?.value}
                title={centerLabel.title}
              />
            )}
            position="center"
          />
        ) : (
          <></>
        )}
      </Pie>
    </PieChart>
  );
};

export default CustomPieChart;
